export default __webpack_public_path__ + "static/media/APayMark.04030e66.svg";